import React from 'react';

import {useCmsContent, useUI} from 'coreHooks';

import {useGeneralProvider} from 'brand/app/components/_app-config/GeneralProvider';

const PreorderShipmentDate = () => {
	const {managerRepository} = useGeneralProvider();
	const variationGroupId = useUI('variationGroupId');

	const {data} = useCmsContent({
		contentType: 'text',
		config: {
			variables: {
				id: `preorderShipmentDate-${variationGroupId}`,
			},
		},
		collectionKey: 'textCollection',
	});

	const cmsProvider = managerRepository.getContentMgr().getCMSProvider();
	const cmsDataBuilder = cmsProvider.getBuilder();
	const shipmentDate = data?.textCollection?.items?.map((b) => cmsDataBuilder.build(b)) ?? null;

	return (
		<div>{shipmentDate}</div>
	);
};

export default React.memo(PreorderShipmentDate);
